<template>
  <div class="w-full">
    <label class="input-label" v-if="$validate.DataValid(label)">{{ $t(label) }}</label>
    <div class="d-flex justify-space-between">
      <div class="w-full">
        <FormTimePicker
          v-if="dynamic"
          :fieldValue="startTimeValue"
          :options="startTimeOptions"
          @changed="_onStartTimeChanged($event)"
          :required="required"
          :hideDetails="hideDetails"
          :readonly="readonly"
          :placeholder="placeholder"
          :disabled="disabled"
          :dispatchUpdateOnChange="dispatchUpdateOnChange"
          :enableClear="enableClear"
        />
        <FormSelect
          v-else
          :fieldValue="startTimeValue"
          :options="startTimeOptions"
          @changed="_onStartTimeChanged($event)"
          :required="required"
          :hideDetails="hideDetails"
          :readonly="readonly"
          :placeholder="placeholder"
          :disabled="disabled"
          :dispatchUpdateOnChange="dispatchUpdateOnChange"
          :enableClear="enableClear"
        />
      </div>

      <span class="body-2 colorBlack--text mt-3 mx-5">{{ $t('to') }}</span>
      <div class="w-full">
        <FormTimePicker
          v-if="dynamic"
          :fieldValue="endTimeValue"
          :options="endTimeOptions"
          @changed="_onEndTimeChanged($event)"
          :readonly="readonly || !$validate.DataValid(startTimeValue)"
          :required="required || $validate.DataValid(startTimeValue)"
          :hideDetails="hideDetails"
          :placeholder="placeholder"
          :disabled="disabled"
          :dispatchUpdateOnChange="dispatchUpdateOnChange"
          :enableClear="enableClear"
        />
        <FormSelect
          v-else
          :fieldValue="endTimeValue"
          :options="endTimeOptions"
          @changed="_onEndTimeChanged($event)"
          :readonly="readonly || !$validate.DataValid(startTimeValue)"
          :required="required || $validate.DataValid(startTimeValue)"
          :hideDetails="hideDetails"
          :placeholder="placeholder"
          :disabled="disabled"
          :dispatchUpdateOnChange="dispatchUpdateOnChange"
          :enableClear="enableClear"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormSelect from './FormSelect.vue'
import FormTimePicker from './FormTimePicker.vue'
export default {
  name: 'FormRangeTimePicker',
  components: {
    FormSelect,
    FormTimePicker,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    dynamic: {
      type: Boolean,
      required: false,
      default: false,
    },
    startTimeValue: {
      type: String,
      required: true,
      default: '',
    },
    endTimeValue: {
      type: String,
      required: true,
      default: '',
    },
    timeInterval: {
      type: Number,
      required: false,
      default: 0,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    dispatchUpdateOnChange: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableClear: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    startTimeOptions() {
      let _interval = this.timeInterval > 0 ? this.timeInterval : this.$settings.interval
      const startTime = this.$settings.startTime
      const endTime = this.$settings.endTime
      const list = []
      const endTimeDate = this.$formatter.convertDate('2023-01-01', endTime);
      const tempDate = this.$formatter.convertDate('2023-01-01', startTime);

      while (tempDate.getTime() < endTimeDate.getTime()) {
        list.push(`${this.$formatter.pad(tempDate.getHours())}:${this.$formatter.pad(tempDate.getMinutes())}`)
        tempDate.setTime(tempDate.getTime() + _interval * 60 * 1000)
      }

      return list
    },
    endTimeOptions() {
      if (!this.startTimeValue || !/^\d{2}:\d{2}$/.test(this.startTimeValue)) {
        return []
      }

      let _interval = this.timeInterval > 0 ? this.timeInterval : this.$settings.interval
      const endTime = this.$settings.endTime
      const endTimeDate = this.$formatter.convertDate('2023-01-01', endTime);
      const tempDate =  this.$formatter.convertDate('2023-01-01', this.startTimeValue);

      const list = []
      while (tempDate.getTime() <= endTimeDate.getTime()) {
        tempDate.setTime(tempDate.getTime() + _interval * 60 * 1000)
        if (tempDate.getTime() <= endTimeDate.getTime()) {
          list.push(`${this.$formatter.pad(tempDate.getHours())}:${this.$formatter.pad(tempDate.getMinutes())}`)
        }
      }

      return list
    },
  },
  methods: {
    _onStartTimeChanged(value) {
      this.$emit('update:endTimeValue', '')
      this.$emit('update:startTimeValue', value || '')
      this.$emit('start-changed', value || '')
      this.$emit('changed', {
        start_time: value || '',
        end_time: this.endTimeValue,
      })
    },
    _onEndTimeChanged(value) {
      this.$emit('update:endTimeValue', value || '')
      this.$emit('end-changed', value || '')
      this.$emit('changed', {
        start_time: this.startTimeValue,
        end_time: value || '',
      })
    },
  },
}
</script>
